import requestApi from "./requestApi";
import { API_CONSTANT_MAP } from "./paths";

export const getAllEspecificas = async (params?: { turmaId?: string }) => {
  let url = API_CONSTANT_MAP.especifica;
  if (params?.turmaId) {
    url += `?turmaId=${params.turmaId}`;
  }
  return requestApi.get(url);
};

export const getEspecificaById = async (id: string | number) => {
  return requestApi.get(`${API_CONSTANT_MAP.especifica}/${id}`);
};

export const saveEspecifica = async (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.especifica, payload);
}; 